const STORAGE_KEY = 'dechess-pending-outgoing-challenge-v1';

export function loadPendingOutgoingChallenge() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.challenge?.challengeId || !parsed?.challenge?.gameId) {
      return null;
    }
    if (parsed.challenge.expiresAt && parsed.challenge.expiresAt <= Date.now()) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function savePendingOutgoingChallenge(entry) {
  try {
    if (!entry) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export function clearPendingOutgoingChallenge() {
  savePendingOutgoingChallenge(null);
}

/** Build an incoming-challenge-shaped object from a hello pendingChallenge offer. */
export function challengeFromHelloOffer(offer, senderId, { now = Date.now() } = {}) {
  if (!offer || typeof offer !== 'object') {
    return null;
  }
  if (!offer.challengeId || !offer.gameId || !offer.targetPlayerId) {
    return null;
  }
  if (!offer.challenger?.playerId || !offer.challenger?.peerId) {
    return null;
  }
  if (offer.challenger.peerId !== senderId) {
    return null;
  }
  if (offer.expiresAt && offer.expiresAt <= now) {
    return null;
  }
  return {
    challengeId: offer.challengeId,
    gameId: offer.gameId,
    challenger: {
      playerId: offer.challenger.playerId,
      peerId: offer.challenger.peerId,
      nickname: offer.challenger.nickname || '',
      country: offer.challenger.country || ''
    },
    targetPlayerId: offer.targetPlayerId,
    timeControl: offer.timeControl || '3+0',
    variant: offer.variant || 'standard',
    rated: Boolean(offer.rated),
    sentAt: offer.sentAt || now,
    expiresAt: offer.expiresAt || now + 15 * 60 * 1000,
    via: 'hello'
  };
}
